export default __webpack_public_path__ + "static/media/admin_product_discount.85f42b81.svg";